import {Component, OnInit, Pipe, PipeTransform} from '@angular/core';
import {AGREEMENT_LINK} from "../../shared/constants";
import {MyGreenCountry} from "../../services/mygreencountry/my-greencountry";
import {PreloaderService} from "../../services/preloader/preloader.service";
import {StudentService} from "../../services/mygreencountry/student.service";
import {StudentExamAnswerApiResponse, StudentTestsApiResponse} from "../../types/apiResponse.interface";
import {ExamsData, testComment} from "../../types/interfaces";
import {StudentRequestComponent} from "../../shared/components/modals/student-request/student-request.component";
import {ModalController} from "@ionic/angular";
import {EditChildPhotoComponent} from "../../shared/components/modals/edit-child-photo/edit-child-photo.component";
import {ViewTestComponent} from "../../shared/components/modals/view-test/view-test.component";
import {DomSanitizer, SafeResourceUrl, SafeUrl, Title} from "@angular/platform-browser";
import {TranslocoService} from "@jsverse/transloco";
import {Observable} from "rxjs";

@Component({
    selector: 'app-tests',
    templateUrl: './tests.page.html',
    styleUrls: ['./tests.page.scss'],
})
export class TestsPage implements OnInit {
    title$: Observable<string>;

    activeCurrentTestTabs: boolean = true;
    hasTests: boolean = true;
    expiredTestTabs: boolean = false;
    completedTestTabs: boolean = false;
    hasTerminatedTests: boolean = true;

    examsData: ExamsData;


    constructor(public myGcService: MyGreenCountry,
                private preloaderService: PreloaderService,
                private studentService: StudentService,
                private modalCtrl: ModalController,
                private sanitizer: DomSanitizer,
                private translocoService: TranslocoService,
                private titleService: Title
    ) {
        this.title$ = this.translocoService.selectTranslate('route.testAndResult');

        this.title$.subscribe(title => {
            this.titleService.setTitle(title);
        });
    }

    ngOnInit() {
        // this.loadTests();
    }

    ionViewDidEnter() {
        this.loadTests();
    }

    refresh(event: any) {
        this.loadTests(event);
    }


    async goToTest(uuid: string) {
        await this.preloaderService.showLoading("Зачекайте, будь ласка ");

        this.studentService.getExamUrl(uuid)
            .subscribe({
                next: (response: StudentExamAnswerApiResponse) => {
                    if (response.url) {
                        this.openUrl(response.url)
                    }
                },

                error: (error) => {
                    console.log('error', error)

                },

                complete: () => {
                    this.preloaderService.hideLoading();
                }

            })

    }


    async checkResult(uuid: string) {
        await this.preloaderService.showLoading("Зачекайте, будь ласка ");
        let exam = this.examsData.completedExams.find(ex => ex.uuid === uuid);
        let comment: testComment = {
            text: exam?.comment,
            comment_at: exam?.comment_at,
            comment_by: exam?.comment_by
        }

        this.studentService.showExamAnswers(uuid)
            .subscribe({
                next: (response: StudentExamAnswerApiResponse) => {
                    // let safeUrl = this.sanitizer.bypassSecurityTrustUrl(response.url);

                    if (response.url) {
                        this.openTestModal(response.url, comment)
                    }
                },

                error: (error) => {
                    console.log('error', error)

                },

                complete: () => {
                    this.preloaderService.hideLoading();
                }

            })

    }

    async loadTests(event: any = null) {
        await this.preloaderService.showLoading("Зачекайте, будь ласка ");

        this.studentService.getExams()
            .subscribe({

                next: (response: StudentTestsApiResponse) => {

                    this.examsData = response.examsData

                },

                error: (error) => {
                    console.log('error', error)

                },

                complete: () => {
                    this.preloaderService.hideLoading();
                    if (event) {
                        event.target.complete();
                    }
                }

            })
    }

    async openRequestModal(type: string) {

        const modal = await this.modalCtrl.create({
            component: StudentRequestComponent,
            cssClass: 'chose-modal auto-height',
            componentProps: {
                type: type,
            }
        });

        await modal.present();

        const {data, role} = await modal.onWillDismiss();
    }

    openUrl(url: any) {
        this.myGcService.openUrl(url)

    }


    async openTestModal(url: string, comment:testComment ) {

        const safeUrl: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);

        const modal = await this.modalCtrl.create({
            component: ViewTestComponent,
            cssClass: 'auto-height full-height',
            componentProps: {
                url: safeUrl,
                comment: comment
            }
        });

        await modal.present();

        const {data, role} = await modal.onWillDismiss();

    }


    protected readonly AGREEMENT_LINK = AGREEMENT_LINK;
}
